<template>
  <div class="space-y-4">
    <RefundValueProduct
      v-for="(product, index) in selectedItemsWithRefundValues"
      :key="index"
      :product="product"
      :loading="loadingRefundValue"
      :phase3d_care_app="phase3d_care_app"
    />

    <div class="flex justify-start space-x-2 items-center">
      <label for="refund_value">Refund value:</label>
      <LoadingSpinner v-if="loadingRefundValue" class="text-green-600" />
      <input
        v-else
        id="refund_value"
        class="form-input w-32 text-sm leading-5"
        :class="{ 'disabled:opacity-50': !userCanModifyRefund }"
        autocomplete="off"
        v-model="refundValue"
        :disabled="!userCanModifyRefund"
      />
    </div>
  </div>
</template>

<script>
import auth from "@/api/auth";
import { ApiFactory } from "@/api/ApiFactory.js";
import MoneyFormatter from "@/mixins/moneyFormatter";
import RefundValueProduct from "./RefundValueProduct.vue";

const Order = ApiFactory.get("orders");

export default {
  name: "RefundValueSummary",
  components: {
    RefundValueProduct,
  },
  filters: {
    currency: MoneyFormatter.format,
  },
  mixins: [MoneyFormatter],
  props: {
    selectedItems: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    phase3d_care_app: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      refundValue: null,
      refundItems: [],
      loadingRefundValue: false,
      showRefundDetails: false,
    };
  },
  computed: {
    order() {
      return this.$store.getters["orders/get"]("order");
    },
    selectedItemsWithRefundValues() {
      return this.selectedItems.map((product) => {
        return {
          ...product,
          refund: this.getRefundItem(product.sku),
        };
      });
    },
    userCanModifyRefund() {
      return auth.isUserAuthorized(["supervisor", "third-party"]);
    },
  },
  watch: {
    selectedItems() {
      this.loadRefundValue();
    },
    refundValue(value) {
      this.$emit("update:refund-value", value);
    },
  },
  created() {
    this.loadRefundValue();
  },
  methods: {
    loadRefundValue() {
      this.loadingRefundValue = true;

      Order.getRefundValue(this.order.SourceOrderNumber, {
        products: this.selectedItems,
      }).then((response) => {
        this.refundValue = Math.round(100 * response.data.body.total) / 100;
        this.refundItems = response.data.body.items;
        this.loadingRefundValue = false;
      });
    },
    getRefundItem(sku) {
      let item = this.refundItems.find(
        (item) => item?.orderDetail?.SKU === sku
      );

      return item !== undefined
        ? item
        : {
            quantity: 0,
            price: { value: 0, taxes: 0 },
            warranty: { value: 0, taxes: 0 },
            oversizedHandlingFee: { value: 0, taxes: 0 },
            discount: { value: 0, taxes: 0 },
            shipping: { value: 0, taxes: 0 },
            totals: { value: 0, taxes: 0 },
            orderDetail: {},
            shopifyDetail: {},
          };
    },
  },
};
</script>
